import React, { PureComponent } from 'react'
import ReportItem from './components/reportItem'
import { Container, Row, Col } from 'reactstrap'
import { postureReport } from '../../utils/mockData'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

const reportData = postureReport()

class Report extends PureComponent {
  componentWillMount () {
    return this.props.user ? null : this.props.history.push('/unauthorized')
  }

  render () {
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className='page-title'>Posture Report</h3>
            <h3 className='page-subhead subhead'>All your compliance report details in one view!</h3>
          </Col>
        </Row>
        <Row>
          {
            reportData.map(report => {
              return <ReportItem key={uuid()} title={report.title} img={report.img} data={report.data} />
            })
          }
        </Row>
      </Container>
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps)(withRouter(Report))



// WEBPACK FOOTER //
// ./src/components/report/Report.js